module.exports = __webpack_public_path__ + "static/media/icon-service-modulesA1.f60e55f0.png";